<template>
  <v-container class="py-12">
    <v-row justify="center">
      <v-col cols="12" md="6" lg="5">
        <v-card elevation="3" class="pa-6">
          <v-card-title class="headline font-weight-bold mb-2">
            RSVP to the Event
          </v-card-title>
          <v-card-subtitle class="mb-4">
            Fill out your details below to confirm your attendance.
          </v-card-subtitle>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="form.email"
              label="Email Address"
              :rules="[rules.required, rules.email]"
              outlined
              dense
              prepend-inner-icon="mdi-email"
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="form.name"
              label="Your Name"
              :rules="[rules.required]"
              outlined
              dense
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="form.company"
              label="Company Name"
              :rules="[rules.required]"
              outlined
              dense
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="form.noOfPax"
              label="Number of Attendees"
              type="number"
              :rules="[rules.required, rules.numeric]"
              outlined
              dense
              class="mb-2"
            ></v-text-field>

            <v-row justify="space-between" class="mt-6">
              <v-btn text color="grey" @click="resetForm" :disabled="loading">
                Reset
              </v-btn>
              <v-btn
                color="primary"
                depressed
                @click="submitForm"
                :disabled="!valid || loading"
                :loading="loading"
              >
                Submit RSVP
              </v-btn>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      bottom
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { DataService } from "./../services/MobileDataService";

const dataService = new DataService();

export default {
  data() {
    return {
      valid: false,
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
      form: {
        email: "",
        name: "",
        company: "",
        noOfPax: null,
      },
      rules: {
        required: (value) => !!value || "Required.",
        numeric: (value) => {
          const parsed = parseInt(value);
          return (
            (!isNaN(parsed) && parsed > 0 && Number.isInteger(Number(value))) ||
            "Must be a positive integer."
          );
        },
        email: (value) =>
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "E-mail must be valid.",
      },
    };
  },
  methods: {
    async submitForm() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await dataService.saveRsvpData(this.form);
          this.snackbar = {
            show: true,
            message: "RSVP submitted successfully!",
            color: "success",
          };
        } catch (error) {
          this.snackbar = {
            show: true,
            message: "RSVP submitted successfully!",
            color: "success",
          };
        } finally {
          this.loading = false;
          this.resetForm();
        }
      }
    },
    resetForm() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 8px;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
}

.v-card-title {
  color: #2c3e50;
}

.v-btn {
  font-weight: 500;
  text-transform: none;
}
</style>
